import {ConditionOperator} from 'common/constants/survey';
import {Condition, ConditionGroup} from 'common/models/survey';

const checkConditionGroup = (
    conditionGroup: ConditionGroup,
    checkCondition: (condition: Condition) => boolean,
) => {
    let memo = false;

    conditionGroup.items.forEach((condition, index) => {
        if (index === 0) {
            memo = memo || checkCondition(condition);
        } else {
            switch (condition.operator) {
                case ConditionOperator.And:
                    memo = memo && checkCondition(condition);
                    break;
                case ConditionOperator.Or:
                    memo = memo || checkCondition(condition);
                    break;
            }
        }
    });

    return memo;
};

const checkConditionGroups = (
    conditionGroups: ConditionGroup[],
    checkCondition: (condition: Condition) => boolean,
) => conditionGroups.some((conditionGroup) => checkConditionGroup(conditionGroup, checkCondition));

export default checkConditionGroups;
